<script lang="ts">
  import { getContext, onMount } from 'svelte';
  import { get } from 'svelte/store';
  import ChooseTrainingView from './MyFitness/Today/ChooseTrainingView.svelte';
  import { getAllWorkouts } from './Util/api';
  import { connectedWorkoutPlayers } from './Singletons/WorkoutPlayersWritable';
  import type { MyFitnessStores } from './MyFitness/stores';

  export let getWorkoutsURL: string;

  const myFitness = getContext<MyFitnessStores>('myFitness');

  let isLoading: boolean = false;
  let allWorkouts = [];
  loadWorkouts();

  async function loadWorkouts() {
    isLoading = true;
    const response = await getAllWorkouts(new Date(), getWorkoutsURL);
    allWorkouts = response?.exercises;
    // This page's blade has no training advice to seed MyFitness with, but the workout list
    // request computes it anyway and sends it back. Keep it: workouts, unlike activities, carry
    // no signature of their own, so the details dialog needs the advice's to build their chart.
    // Only fills an empty store, so a page that was given real advice keeps it.
    const advice = response?.training_advice;
    if (advice && myFitness && !get(myFitness.trainingAdvice)) {
      if (advice.timestamp) myFitness.trainingAdviceUpdatedAt.set(new Date(advice.timestamp));
      myFitness.trainingAdvice.set(advice);
    }
    isLoading = false;
  }

  onMount(function () {
    connectedWorkoutPlayers.init();
  });

</script>

<dashboard class='xert-svelte h-full flex flex-row gap-4 border-solid border-0 border-t border-border'>
  <ChooseTrainingView
    {isLoading}
    originalExercises={allWorkouts}
    onClickCard={'view details'}
    showAddWorkoutButtons
  />
</dashboard>
